import { render, staticRenderFns } from "./DashboardStatus.vue?vue&type=template&id=52955e88&scoped=true&lang=html&"
import script from "./DashboardStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52955e88",
  null
  
)

export default component.exports